export class CswUiValues {
  constructor() {
    this.daysOfWeek = new DOWType();
  }

  id: string;
  ForthCell: ItemType[];
  ThirdCell: ItemType[];
  Type: ItemType[];
  Value: ItemType[];
  SecondCell: ItemType[]; // Used only for weights
  FirstCell: ItemType[];
  Weight: number; // Used only for weights
  selectedForthCell: any = null;
  selectedThirdCell: any = null;
  selectedTypeCell: any = null;
  selectedValueCell: any = null;
  selectedSecondCell: any = null;
  selectedFirstCell: any = null;
  bulkCities: BulkCitiesType[];
  calenderValues: CalenderType[];
  daysOfWeek: DOWType;
  daysOfMonth: SDOM;
  bulkCitiesWeight: WeightModel[] = [];
  sortName: string;
  sortSubCatergories: ItemType[];
  commutableAuto: CommutableAutotype;
  commuteManual: CommuteManualType;
  reportRelease: ReportReleaseType;
  redEye:redEyeType;
}

export class ItemType {
  constructor(key, value) {
    this.key = key;
    this.value = value;
  }
  key: any;
  value: any;
}

export class BulkCitiesType extends ItemType {
  constructor(key, value, isEnabled, status) {
    super(key, value);
    (this.isEnabled = isEnabled), (this.status = status);
  }
  isEnabled: boolean;
  status: any;
}

export class CalenderType extends ItemType {
  constructor(key, value) {
    super(key, value);
    this.Mode = 0;
    this.DefaultDisplayDay = value;
  }

  public IsEnabled: boolean;
  public CalenderDate: string;
  public Day: string = null;
  public Status: boolean = null;
  public Mode = 0; // TODO: Need to set an Enum :-  Abhi
  public DefaultDisplayDay: string;
}

export class DOWType {
  public IsWorkEnabled: boolean;

  public weekDays: WeightModel[] = [];
}

export class SDOM {
  constructor() {
    this.day = [];
    this.workEnabled = false;
  }

  public day: WeightModel[];

  public workEnabled: boolean;
}

export class WeightModel extends ItemType {
  constructor(
    id: number,
    weight: any,
    text: string,
    enabled?: boolean,
    cityMode?: number
  ) {
    super(id, weight);
    this.Text = text;
    this.enabled = enabled;
    this.overNightCityMode = cityMode;
  }
  public Text: string;
  public enabled: boolean;
  public overNightCityMode = 0;
  public mode = 0; // mode 1 = normal, mode  1 = green, mode 2 = red
  public calenderDate: string;
  public status: any;
}

export class CommutableAutotype {
  selectedCity: string;
  noNightinMiddle: ItemType;
  toWork: ItemType;
  toHome: ItemType;
  connectTimeValues: ItemType[] = [];
  takeOffPadTimeValues: ItemType[] = [];
  backToBasePadTimeValues: ItemType[] = [];
  commuteOptions: ItemType[] = [];
  selectedConnectTime: any;
  selectedTakeOffPadTimeValues: any;
  selectedBackToBasePadTimeValues: any;
  selectedCommuteAutoOption: any;
  isNonStopOnly: boolean;
}

export class CommuteManualType {
  commuteToWork: ItemType;
  commuteToHome: ItemType;
  anyNightInDom: ItemType;
  ronBothEnds: ItemType;
  monTHuCheckIn: ItemType;
  fridayCheckIn: ItemType;
  saturdayCheckIn: ItemType;
  sundayCheckIn: ItemType;
  monTHuBase: ItemType;
  fridayBase: ItemType;
  saturdayBase: ItemType;
  sundayBase: ItemType;
  commuteOptions: ItemType[] = [];
  selectedCommuteManualOption: any;
  isNeedToDisableRON: boolean;
}

export class ReportReleaseType {
  public allDays: ItemType;

  public tripBlock: ItemType;

  public first: ItemType;

  public last: ItemType;

  public noMid: ItemType;

  public report: ItemType;

  public release: ItemType;
}
export class redEyeType{
  redEyeSortOptions:ItemType[] = [];
  selectedRedeyeSortOption: any;
}
